import React from "react";
import { Grid, Box, CircularProgress, Typography, Paper, Divider } from "@mui/material";
import PropTypes from "prop-types";
import { footNotesHeader } from "./ProjectJobsConstant";
import { InfoCard } from "./InfoCard";
import { StatCard } from "./StatCard";
import { AdditionalFringeCard } from "./AdditionalFringeCard";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import SpeedIcon from "@mui/icons-material/Speed";
import RatesIcon from "../../../Assets/Icons/rates.png";
import FringeIcon from "../../../Assets/Icons/fringe.png";
import ScoreIcon from "../../../Assets/Icons/score.png";

export const RenderContentPwc = ({
  isWagesLoader,
  chatBotFringes,
  chatBotRates,
  chatBotMatchScore,
  isNoStateOrCountyData,
  errorMsg,
  footNotes,
  source
}) => {
  if (isWagesLoader) {
    return (
      <Box sx={{ m: 5, height: 100, textAlign: "center" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <CircularProgress />
          </Grid>
        </Grid>
      </Box>
    );
  }
  if (chatBotFringes) {
    return (
      <Box>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={3.8}>
            <StatCard icon={RatesIcon} label="Rates" value={`$${chatBotRates}`} iconBgColor="#C3FFC3" cardBgColor="#E3FFE3" />
          </Grid>
          <Grid item xs={12} sm={3.8}>
            <StatCard icon={FringeIcon} label="Fringe" value={`$${chatBotFringes}`} iconBgColor="#ffe0b2" cardBgColor="#fff5e6" />
          </Grid>
          <Grid item xs={12} sm={4.4}>
            <StatCard icon={ScoreIcon} label="Confidence Score" value={`${chatBotMatchScore}%`} iconBgColor="#cfcfff" cardBgColor="#ededff" />
          </Grid>
        </Grid>
        <Divider sx={{ my: 2 }} />
        <Grid container spacing={2}>
          {source?.groupName && (
            <Grid item xs={12} sm={6}>
              <InfoCard label="Group" value={source?.groupName || ""} />
            </Grid>
          )}
          {source?.equipment && (
            <Grid item xs={12} sm={6}>
              <InfoCard label="Equipment" value={source?.equipment.join(", ") || ""} />
            </Grid>
          )}
        </Grid>
        {(source?.groupName || source?.equipment) && <Divider sx={{ my: 2 }} />}

        {source?.additional_fringe_explanation && (
          <>
            <AdditionalFringeCard explanation={source?.additional_fringe_explanation} />
            <Divider sx={{ my: 2 }} />
          </>
        )}

        {Object.keys(footNotes)?.map(
          key =>
            footNotes[key] !== "" &&
            Object.keys(footNotes[key])?.length !== 0 && (
              <div className="pwc_section_footnotes" key={key}>
                <div className="pwc-top" style={{ backgroundColor: "#FFF7E8" }}>
                  <div className="pwc-top_right">
                    <h3>{footNotesHeader[key]}</h3>
                    {key === "otherFootnotes" ? (
                      Object.keys(footNotes[key])?.map(otherkey => <h5 key={otherkey}>{`(${otherkey}). ${footNotes[key][otherkey]}`}</h5>)
                    ) : (
                      <h5>{footNotes[key]}</h5>
                    )}
                  </div>
                </div>
              </div>
            )
        )}
      </Box>
    );
  }
  return (
    <Box sx={{ m: 5, height: 100, textAlign: "center" }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <Typography cla variant="h6" sx={{ fontSize: "12px !important" }}>
            {isNoStateOrCountyData ? "Project does not have a state and county." : errorMsg}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

RenderContentPwc.propTypes = {
  isWagesLoader: PropTypes.bool,
  chatBotFringes: PropTypes.number,
  chatBotRates: PropTypes.number,
  chatBotMatchScore: PropTypes.number,
  isNoStateOrCountyData: PropTypes.bool,
  errorMsg: PropTypes.string,
  footNotes: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.string)]))
};
